export type NamedUser = {
    displayName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
};

export const getUserFullName = (user?: NamedUser): string =>
    [user?.firstName, user?.lastName].filter(Boolean).join(" ");

export const getUserDisplayName = (user?: NamedUser): string =>
    user?.displayName || getUserFullName(user) || user?.email || "Unknown User";

/** The full name, or "" when it would just repeat the display name. */
export const getDistinctFullName = (user?: NamedUser): string => {
    const fullName = getUserFullName(user);
    return fullName !== getUserDisplayName(user) ? fullName : "";
};

/** Up to two initials from the full name, falling back to the display name. */
export const getUserInitials = (user?: NamedUser): string => {
    const name = getUserFullName(user) || user?.displayName;
    const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
    return parts
        .slice(0, 2)
        .map((p) => p[0])
        .join("")
        .toUpperCase();
};

const AVATAR_COLORS = [
    "#3b82f6",
    "#8b5cf6",
    "#ec4899",
    "#f97316",
    "#10b981",
    "#06b6d4",
];

/** Stable avatar background colour derived from the user's name. */
export const getUserAvatarColor = (user?: NamedUser): string => {
    const name = user?.displayName || user?.firstName || user?.email || "";
    if (!name) return "#94a3b8";
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
